<template src='./conciliationReport.pug' lang='pug'></template>

<script>
import GridDetailsModal from '../../../modals/gridDetailsModal/GridDetailsModal'
import MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import { generateFinMovFromNode, generateBankStatFromNode } from '../../../../utils/transformationData.js'
import closeModal from '../../../../events/closeModal'
import FunctionalitieIdEnum from '../../../../enum/funcionalidadeId'

export default {
  name: 'ConciliationReport',

  components: {
    GridDetailsModal,
    MultiSelectModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    InputEstablishment,
    ButtonPrimary,
    TreeGrid
  },

  data () {
    return {
      establishimentsUrls: {
        establishments: 'conciliationReport/establishment/list',
        attributes: '/conciliationReport/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isExportFile: false,
      isAdvancedSearch: true,
      gridId: '#RelatorioConciliacao',
      treeGridCfg: {},
      audit: {},
      dateRange: {},
      situationList: [
        {
          id: 'A',
          nome: this.$t('statusConciliacao.aberto'),
          checked: true
        },
        {
          id: 'C',
          nome: this.$t('statusConciliacao.conciliado'),
          checked: true
        },
        {
          id: 'M',
          nome: this.$t('statusConciliacao.conciliadoManualmente'),
          checked: true
        },
        {
          id: 'D',
          nome: this.$t('statusConciliacao.divergente'),
          checked: true
        },
        {
          id: 'N',
          nome: this.$t('statusConciliacao.naoAplicavel'),
          checked: true
        }
      ],
      selectedStatuses: ['A', 'C', 'M', 'D', 'N'],
      firstDate: new Date(),
      finalDate: new Date(),
      showTreegrid: false,
      exportUrl: EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'RelatorioConciliacao',
      dataTableColumns: [],
      disableSearchButton: false,
      firstTimeBank: true,
      detailsObj: {
        establishtmentValue: {},
        mainValuesList: [],
        monetaryValuesList: [],
        statusValuesList: [],
        integrationValuesList: [],
        classificationValuesList: [],
        idProcessamento: -1
      },
      concReportGridModalId: '',
      isOpenDetailsModal: false,
      firstTime: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      firstTimeAccount: true,
      modalDetailsTabs: [],
      filterable: [],
      attList: [],
      columnsFilterable: [],
      customFilters: [],
      showCustomColumns: false,
      firstTimeCategorie: true,
      customSetOrder: null,
      shown: {
        bankAccounts: false,
        categories: false
      },
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        },
        categories: {
          id: 'id',
          name: 'nome'
        }
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }],
        categories: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todas')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('extratoBancario.labels.contasBancarias'),
            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              banco: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1
                }
              },
              agencia: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia
                  }
                  return a.numAgencia >= b.numAgencia
                }
              },
              conta: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1
                  }
                  return +a.conta <= +b.conta ? 1 : -1
                }
              }
            },
            templates: {
              nome: (h, row) => {
                let txt = row.nome
                if (!row.ativo) {
                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'
                }
                return txt
              },
              banco: (h, row) => {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome
                }
                return '-'
              },
              agencia: (h, row) => {
                let txt = '-'
                if (row.agencia) {
                  txt = row.numAgencia
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia
                  }
                }
                return txt
              },
              conta: (h, row) => {
                let txt = row.conta
                if (row.digConta) {
                  txt += '-' + row.digConta
                }
                return txt
              }
            }
          }
        },
        categories: {
          titles: {
            main: this.$t('categoria.titulos.titulo'),
            sub: this.$t('categoria.labels.selecionarCategoria')
          },
          selectedItems: [],
          columns: ['numero', 'nome', 'idContabil', 'tipo'],
          values: [],
          options: {
            columnsClasses: { numero: 'col-md-3', nome: 'col-md-4', idContabil: 'col-md-2', tipo: 'col-md-3' },
            perPage: 5,
            headings: {
              numero: this.$t('categoria.modal.labels.numero'),
              nome: this.$t('categoria.modal.labels.descricao'),
              idContabil: this.$t('categoria.modal.labels.idContabil'),
              tipo: this.$t('categoria.modal.labels.tipo')
            },
            filterable: ['numero', 'nome', 'idContabil', 'tipo'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['numero', 'nome', 'idContabil', 'tipo'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'numero'
            },
            customSorting: {
              numero: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.ordem >= b.ordem ? 1 : -1
                  }
                  return a.ordem <= b.ordem ? 1 : -1
                }
              },
              nome: function (asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              },
              idContabil: function (asc) {
                return function (a, b) {
                  const idA = a.idContabil
                  const idB = b.idContabil
                  if (idA === null || idB === null) {
                    if (asc) {
                      return idA === null ? -1 : 1
                    }
                    return idA === null ? 1 : -1
                  }
                  if (asc) {
                    return a.idContabil.toLowerCase().localeCompare(b.idContabil.toLowerCase())
                  }
                  return b.idContabil.toLowerCase().localeCompare(a.idContabil.toLowerCase())
                }
              },
              tipo: function (asc) {
                return function (a, b) {
                  if (asc) {
                    return a.tipo.toLowerCase().localeCompare(b.tipo.toLowerCase())
                  }
                  return b.tipo.toLowerCase().localeCompare(a.tipo.toLowerCase())
                }
              }
            },
            templates: {
              idContabil: (h, row) => {
                return row.idContabil || '-'
              },
              tipo: (h, row) => {
                return this.$t(`categoria.modal.labels.${row.tipo}`)
              }
            }
          }
        }
      }
    }
  },

  watch: {
    situationList: {
      handler (val) {
        this.selectedStatuses = []
        val.forEach(st => {
          if (st.checked) {
            this.selectedStatuses.push(st.id)
          }
        })
      },
      deep: true
    }
  },

  methods: {
    setFilter () {
      return {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),
        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
        idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),
        idsCategorias: this.data.categories.selectedItems.map(selected => selected.id).filter(categories => categories !== '-1'),
        situacoesConciliacao: this.selectedStatuses,
        lang: language.getCookieByName('language')
      }
    },

    resetFilter () {
      this.selectedEstablishments = []
      this.data.bankAccounts.selectedItems = []
      this.data.bankAccounts.considerInactiveAccounts = false
      this.data.categories.selectedItems = []
      this.situationList.forEach(situation => {
        situation.checked = true
      })
      this.selectedStatuses = ['A', 'C', 'M', 'D', 'N']
    },

    getLoadingMessages () {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid']
    },

    validate () {
      let self = this
      let promise = null
      return new Promise(resolve => {
        this.$validator.validateAll().then((result) => {
          if (result && self.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download()
            } else {
              self.showTreegrid = true
              startTreeGridLoading(self.gridId, self.getLoadingMessages())
              promise = self.search()
            }
            promise.finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    download () {
      this.disableSearchButton = true
      let filter = this.setFilter()
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchConciliationReportToFile', filter).then(() => {
          this.disableSearchButton = false
          resolve()
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
          this.disableSearchButton = false
          reject()
        })
      })
    },

    search () {
      this.disableSearchButton = true
      let filter = this.setFilter()

      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchConciliationReport', filter)
          .then((response) => {
            if (window.Grids[0]) {
              window.DisposeGrids()
            }
            this.result = response.data
            this.treeGridCfg = response.data.Cfg.Layout
            window.Grids.abrirModalDetalhes = (row) => {
              trackAnalyticsEvent(this, 'row-click', 'relatorio-conciliacao-grid-details', row.IdConciliacaoLote)
              if (row.IdExtBancario) {
                this.concReportGridModalId = 'concReportGridModalIdMov-' + row.IdExtBancario
                this.$store.dispatch('getBankStatementById', row.IdExtBancario).then((response) => {
                  this.detailsObj = generateBankStatFromNode(response.data)
                  this.detailsObj.statusLancamento = response.data.situacaoConciliacao
                  this.generateModalTabs('MovBan', row.IdContaLancamento)
                  setTimeout(() => {
                    this.showDetailsModal()
                    window.Grids[0].Disable()
                  }, 100)
                }).catch((error) => {
                  if (error.message) {
                    this.$root.$refs.notification.error(error.message)
                  } else {
                    // Validação específica do parse dosq dados
                    this.$root.$refs.notification.error('modalDetalhesLanc.error.parseError')
                  }
                })
              } else {
                this.concReportGridModalId = 'concReportGridModalIdMov-' + row.IdMovFinanceiro
                let obj = {
                  url: '/conciliationReport/getFinancialMovById',
                  id: row.IdMovFinanceiro
                }

                this.$store.dispatch('getFinancialMovementById', obj).then((response) => {
                  this.detailsObj = generateFinMovFromNode(response.data)
                  this.detailsObj.statusLancamento = response.data.situacaoConciliacao
                  this.generateModalTabs('MovFin')
                  setTimeout(() => {
                    this.showDetailsModal()
                    window.Grids[0].Disable()
                  }, 100)
                }).catch((error) => {
                  if (error.message) {
                    this.$root.$refs.notification.error(error.message)
                  } else {
                    // Validação específica do parse dos dados
                    this.$root.$refs.notification.error('modalDetalhesLanc.error.parseError')
                  }
                })
              }
            }
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            resolve()
          }).catch((error) => {
            this.$root.$refs.notification.error(error)
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            reject()
          })
      })
    },

    openSelectBankAccountsModal () {
      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true
        return
      }
      this.$store.dispatch('getBankAccounts', '/conciliationReport/bankAccounts/list')
        .then(response => {
          this.data.bankAccounts.allBankAccounts = response.data.data
          this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {
            return !bankAccount.ativo
          })
          this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {
            return bankAccount.ativo
          })
          this.shown.bankAccounts = true
        })
    },

    openSelectCategoriesModal () {
      if (this.data.categories.values.length > 0) {
        this.shown.categories = true
        return
      }
      this.$store.dispatch('getCategories', {
        url: '/conciliationReport/loadCategories',
        flTipoCategoria: 'A,C,D',
        validarUso: false
      })
        .then((response) => {
          this.data.categories.values = response.data
          this.shown.categories = true
        })
    },

    showDetailsModal () {
      this.isOpenDetailsModal = true
    },

    closeDetailsModal () {
      this.isOpenDetailsModal = false
    },

    closeModal () {
      this.shown.bankAccounts = false
      this.shown.categories = false
    },

    generateModalTabs (tipoMovimento, idContaLanc) {
      let tabs = []
      // push tab details
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          establishtmentValue: this.detailsObj.establishtmentValue,
          mainValuesList: this.detailsObj.mainValuesList,
          statusValuesList: this.detailsObj.statusValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList,
          commentary: this.detailsObj.commentary
        }
      })

      if (tipoMovimento !== 'MovFin') {
        // push tab classification
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabClassification',
          idTabContent: 'tab-classification-id',
          idMovimento: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tabClassificationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabClassif'),
          icon: 'tab-icon-font fa fa-handshake-o',
          type: 'TabClassification',
          props: {
            mainValuesList: this.detailsObj.classificationValuesList
          }
        })
      }

      if (this.detailsObj.idProcessamento) {
        // push tab integrations
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value.toString(),
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            establishtmentValue: this.detailsObj.establishtmentValue,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        })
      }

      // push tab historic
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabHistoric',
        idTabContent: 'tab-historic-id',
        idLanc: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tabHisotiricGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),
        icon: 'tab-icon-font fa fa-hourglass',
        type: 'TabHistoric',
        props: {
          loadHistoric: this.detailsObj.idMovimentoBancario ? this.findBankStatementHistory : this.findFinancialMovementHistory,
          idLancamento: this.detailsObj.mainValuesList[0].value.toString()
        }
      })

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabAllotment',
        idTabContent: 'tab-allotment-id',
        idLanc: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tadAllotmentGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabLote'),
        icon: 'tab-icon-font fa fa-cubes',
        type: 'TabAllotment',
        props: {
          getAllotment: tipoMovimento === 'MovFin' ? this.findFinancialMovementAllotment : this.findBankStatAllotment,
          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: tipoMovimento
        }
      })

      // push tab tasks
      tabs.push({
        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: tipoMovimento === 'MovBan' ? idContaLanc.toString() : this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: tipoMovimento,
          statusMovimento: this.detailsObj.statusLancamento
        }
      })
      this.modalDetailsTabs = tabs
    },

    findFinancialMovementHistory (id) {
      let data = {
        conciliationReportId: id,
        url: '/conciliationReport/financialMovementHistoryHistory'
      }
      return this.$store.dispatch('getHistoricConciliationReport', data)
    },

    findBankStatementHistory (id) {
      let data = {
        conciliationReportId: id,
        url: '/conciliationReport/bankStatementHistory'
      }
      return this.$store.dispatch('getHistoricConciliationReport', data)
    },

    findIntegration (id) {
      let data = {
        idProcessamento: id,
        url: '/conciliationReport/getProcessedFilesById'
      }
      return this.$store.dispatch('getProcessedFiles', data)
    },

    findFinancialMovementAllotment (id) {
      let data = {
        idFinancialMovement: id,
        url: '/conciliationReport/getAllotmentByMovFinId'
      }
      return this.$store.dispatch('getAllotmentByMovementId', data)
    },

    findBankStatAllotment (id) {
      let data = {
        idFinancialMovement: id,
        url: '/conciliationReport/getAllotmentByMovBanId'
      }
      return this.$store.dispatch('getAllotmentByMovementId', data)
    }
  },

  mounted () {
    // Listener para evento de atualização de dados dentro da modal de detalhes,
    // o que requer uma nova consulta para o relatório
    const self = this
    closeModal.$on('modalDetaisClose', (flag) => {
      if (flag) {
        self.showTreegrid = true
        startTreeGridLoading(self.gridId, self.getLoadingMessages())
        self.search()
        // Altera a flag que recarrega a treegrid após o recarregamento
        // para impedir que ela seja recarregada sempre após a primeira vez
        closeModal.$emit('taskChange', false)
      }
    })
  }
}
</script>

<style>
.input-button>button {
  margin: 24px 0 0 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  float: left;
}

#logDeAuditoriaWrapper {
  width: 100%;
}

#divTreeGridAuditoria {
  min-width: 100%;
  min-height: 500px;
}

.check {
  text-align: center;
}

.filterButton {
  width: 3vw;
  margin: 0px !important;
}

.col-search {
  width: 53.5%;
}

.search-button {
  min-width: 7vw;
}

.checkbox {
  margin-top: 0px;
  margin-bottom: 0px;
}

.func-group-labels {
  color: #515151;
  font-size: 13px !important;
  text-transform: initial !important;
  font-weight: normal !important;
  padding-top: 1px;
}

.status-filter {
  margin-right: 20px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// ConciliationReport.vue?030cd4f4